// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__P6SUV","options":"AnswerScale_options__2WQBI","selected":"AnswerScale_selected__3XSpO"};